import { Card, Typography } from "antd";
import Chart from "react-apexcharts";

const { Text } = Typography;

const KPIWidget = ({ title, value = '', icon, color, chartType = 'line', chartOptions, chartSeries, height = 60, isChart = true, loading }) => {
    return (
        <Card
            styles={{
                body: { padding: '24px' }
            }}
            style={{
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
                border: '1px solid #f0f0f0',
                height: '100%',
            }}
            loading={loading}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <Text strong>{title}</Text>
                    <div
                        className="total-kpi-value"
                        style={{
                            fontSize: isChart ? '28px' : '46px',
                            fontWeight: 'bold',
                            color: color,
                            marginTop: '8px'
                        }}>
                        {value}
                    </div>
                </div>
                <div style={{ fontSize: 30, color: color, display: 'flex', alignItems: 'start', flexShrink: 0 }}>{icon}</div>
            </div>

            {isChart && <div style={{ marginTop: '12px' }}>
                <Chart
                    options={chartOptions}
                    series={chartSeries}
                    type={chartType}
                    height={height}
                />
            </div>}
        </Card>
    );
};

export default KPIWidget;
